import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { LiveService } from '../services/liveService'

interface UseGetAllLiveProps {
  skip: number
  limit: number
  search?: string
}

export const useGetAllLives = ({ skip, limit, search }: UseGetAllLiveProps) => {
  return useQuery({
    queryKey: ['lives', skip, limit, search],
    queryFn: () => LiveService.getAll(skip, limit, search),
    placeholderData: keepPreviousData,
  })
}
